import { useState } from 'react'

export function useData() {
  const [drawerOpen, setDrawerOpen] = useState(false)

  return { drawerOpen, setDrawerOpen }
}

export type UseData = ReturnType<typeof useData>
